export default "__VITE_ASSET__Ipi0DtpV__"